<template>
  <div class="account-page">
    <Table class="account-table" highlight-row stripe border :columns="columns" :data="datas"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'People',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('People.index') },
        { title: this.$t('People.name'), key: 'name' },
        { title: this.$t('People.workNo'), key: 'workNo' },
        {
          title: this.$t('People.sex'),
          key: 'sex',
          render: (h, params) => {
            let s = params.row.sex === 1 ? this.$t('People.boy') : this.$t('People.girl')
            return h('span', s)
          }
        },
        // {
        //   title: '工种',
        //   key: 'workType',
        //   render: (h, params) => {
        //     if (params.row.workType === null) {
        //       return h('')
        //     }
        //     let wts = []
        //     for (var v of params.row.workType) {
        //       let wt = this.workType[v]
        //       if (wt !== undefined) {
        //         wts.push(wt)
        //       }
        //     }
        //     return h('span', wts.join())
        //   }
        // },
        { title: this.$t('People.phone'), key: 'phone' },
        { title: this.$t('People.entryTime'), key: 'entryTime' },
        { title: this.$t('People.wechat'), key: 'wechat' },
        { title: this.$t('People.qq'), key: 'qq' },
        {
          title: this.$t('People.working'),
          key: 'working',
          render: (h, params) => {
            let s = params.row.working === 1 ? this.$t('People.working1') : this.$t('People.working2')
            return h('span', s)
          }
        },
        {
          title: this.$t('People.action'),
          key: 'action',
          render: (h, params) => {
            if (this.permissions === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, this.$t('People.edit'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('People.edit'))
              ])
            }
          }
        }
      ],
      datas: [],
      workType: {},
      permissions: false
    }
  },
  computed: {
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'PeopleEdit', params: { id } })
    }
  },
  mounted () {
    Api.workType.list().then(res => {
      let wts = {}
      for (var wt of res.workTypes) {
        wts[wt.id] = wt.name
      }
      this.workType = wts
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'people' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.people.list().then(res => {
      next(vm => { vm.datas = res.accounts })
    })
  }
}
</script>
<style>
.account-page {
  padding: 10px;
}

.account-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// List.vue?517af397